import useShipmentDetails from './useShipmentDetails';

export default useShipmentDetails;
